import { useCallback, useEffect, useRef, useState } from 'react';
import { AnalyticsData, fetchAnalytics } from './model';
export default function useAnalyticsData() {
  const [data, setData] = useState<AnalyticsData | null>(null), [loading, setLoading] = useState(true), [error, setError] = useState(''), [updated, setUpdated] = useState<string | null>(null);
  const alive = useRef(true), generation = useRef(0), busy = useRef(false);
  const reload = useCallback(async () => {
    if (busy.current) return;
    const id = ++generation.current; busy.current = true; setLoading(true);
    try {
      const snapshot = await fetchAnalytics();
      if (!alive.current || id !== generation.current) return;
      setData(snapshot); setUpdated(new Date().toISOString()); setError('');
    } catch {
      if (!alive.current || id !== generation.current) return;
      setError('Analiz verileri yenilenemedi. Varsa önceki veriler ve güncelleme zamanı korunuyor.');
    } finally { if (alive.current && id === generation.current) { setLoading(false); busy.current = false; } }
  }, []);
  useEffect(() => { alive.current = true; busy.current = false; reload(); return () => { alive.current = false; generation.current += 1; }; }, [reload]);
  return { data, loading, error, updated, reload };
}
